/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClienteCreateDTO,
  ClienteDTO,
  ClienteUpdateDTO,
  DipendenzaCreateDTO,
  DipendenzaDTO,
  DipendenzaUpdateDTO,
  ProblemDetails,
} from '../models/index';
import {
    ClienteCreateDTOFromJSON,
    ClienteCreateDTOToJSON,
    ClienteDTOFromJSON,
    ClienteDTOToJSON,
    ClienteUpdateDTOFromJSON,
    ClienteUpdateDTOToJSON,
    DipendenzaCreateDTOFromJSON,
    DipendenzaCreateDTOToJSON,
    DipendenzaDTOFromJSON,
    DipendenzaDTOToJSON,
    DipendenzaUpdateDTOFromJSON,
    DipendenzaUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteDipendenzaRequest {
    idCliente: string;
    idDipendenza: string;
}

export interface GetClienteByIdRequest {
    idCliente: string;
}

export interface GetClienteByPartitaIVARequest {
    piva: string;
}

export interface GetDipendenzaByIdRequest {
    idCliente: string;
    idDipendenza: string;
}

export interface GetDipendenzeRequest {
    idCliente: string;
}

export interface InsertClienteRequest {
    clienteCreateDTO?: ClienteCreateDTO;
}

export interface InsertDipendenzaRequest {
    idCliente: string;
    dipendenzaCreateDTO?: DipendenzaCreateDTO;
}

export interface UpdateClienteRequest {
    idCliente: string;
    clienteUpdateDTO?: ClienteUpdateDTO;
}

export interface UpdateDipendenzaRequest {
    idCliente: string;
    idDipendenza: string;
    dipendenzaUpdateDTO?: DipendenzaUpdateDTO;
}

/**
 * 
 */
export class ClientiApi extends runtime.BaseAPI {

    /**
     * Elimina una dipendenza esistente
     */
    async deleteDipendenzaRaw(requestParameters: DeleteDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling deleteDipendenza().'
            );
        }

        if (requestParameters['idDipendenza'] == null) {
            throw new runtime.RequiredError(
                'idDipendenza',
                'Required parameter "idDipendenza" was null or undefined when calling deleteDipendenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}/Dipendenze/{idDipendenza}`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))).replace(`{${"idDipendenza"}}`, encodeURIComponent(String(requestParameters['idDipendenza']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Elimina una dipendenza esistente
     */
    async deleteDipendenza(requestParameters: DeleteDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDipendenzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getClienteByIdRaw(requestParameters: GetClienteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClienteDTO>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling getClienteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClienteDTOFromJSON(jsonValue));
    }

    /**
     */
    async getClienteById(requestParameters: GetClienteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClienteDTO> {
        const response = await this.getClienteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClienteByPartitaIVARaw(requestParameters: GetClienteByPartitaIVARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClienteDTO>> {
        if (requestParameters['piva'] == null) {
            throw new runtime.RequiredError(
                'piva',
                'Required parameter "piva" was null or undefined when calling getClienteByPartitaIVA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/PartitaIVA/{piva}`.replace(`{${"piva"}}`, encodeURIComponent(String(requestParameters['piva']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClienteDTOFromJSON(jsonValue));
    }

    /**
     */
    async getClienteByPartitaIVA(requestParameters: GetClienteByPartitaIVARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClienteDTO> {
        const response = await this.getClienteByPartitaIVARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientiRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClienteDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClienteDTOFromJSON));
    }

    /**
     */
    async getClienti(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClienteDTO>> {
        const response = await this.getClientiRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDipendenzaByIdRaw(requestParameters: GetDipendenzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DipendenzaDTO>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling getDipendenzaById().'
            );
        }

        if (requestParameters['idDipendenza'] == null) {
            throw new runtime.RequiredError(
                'idDipendenza',
                'Required parameter "idDipendenza" was null or undefined when calling getDipendenzaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}/Dipendenze/{idDipendenza}`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))).replace(`{${"idDipendenza"}}`, encodeURIComponent(String(requestParameters['idDipendenza']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DipendenzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getDipendenzaById(requestParameters: GetDipendenzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DipendenzaDTO> {
        const response = await this.getDipendenzaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDipendenzeRaw(requestParameters: GetDipendenzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DipendenzaDTO>>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling getDipendenze().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}/Dipendenze`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DipendenzaDTOFromJSON));
    }

    /**
     */
    async getDipendenze(requestParameters: GetDipendenzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DipendenzaDTO>> {
        const response = await this.getDipendenzeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Crea un nuovo cliente in anagrafica
     */
    async insertClienteRaw(requestParameters: InsertClienteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClienteDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClienteCreateDTOToJSON(requestParameters['clienteCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClienteDTOFromJSON(jsonValue));
    }

    /**
     * Crea un nuovo cliente in anagrafica
     */
    async insertCliente(requestParameters: InsertClienteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClienteDTO> {
        const response = await this.insertClienteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Crea una nuova dipendenza in anagrafica
     */
    async insertDipendenzaRaw(requestParameters: InsertDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DipendenzaCreateDTO>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling insertDipendenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}/Dipendenze`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DipendenzaCreateDTOToJSON(requestParameters['dipendenzaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DipendenzaCreateDTOFromJSON(jsonValue));
    }

    /**
     * Crea una nuova dipendenza in anagrafica
     */
    async insertDipendenza(requestParameters: InsertDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DipendenzaCreateDTO> {
        const response = await this.insertDipendenzaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggiorna un cliente esistente
     */
    async updateClienteRaw(requestParameters: UpdateClienteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling updateCliente().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClienteUpdateDTOToJSON(requestParameters['clienteUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Aggiorna un cliente esistente
     */
    async updateCliente(requestParameters: UpdateClienteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateClienteRaw(requestParameters, initOverrides);
    }

    /**
     * Aggiorna una dipendenza esistente
     */
    async updateDipendenzaRaw(requestParameters: UpdateDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idCliente'] == null) {
            throw new runtime.RequiredError(
                'idCliente',
                'Required parameter "idCliente" was null or undefined when calling updateDipendenza().'
            );
        }

        if (requestParameters['idDipendenza'] == null) {
            throw new runtime.RequiredError(
                'idDipendenza',
                'Required parameter "idDipendenza" was null or undefined when calling updateDipendenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Clienti/{idCliente}/Dipendenze/{idDipendenza}`.replace(`{${"idCliente"}}`, encodeURIComponent(String(requestParameters['idCliente']))).replace(`{${"idDipendenza"}}`, encodeURIComponent(String(requestParameters['idDipendenza']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DipendenzaUpdateDTOToJSON(requestParameters['dipendenzaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Aggiorna una dipendenza esistente
     */
    async updateDipendenza(requestParameters: UpdateDipendenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDipendenzaRaw(requestParameters, initOverrides);
    }

}
